const lang = {
  APP_NAME: "PyChamps",
};

export default lang;
